import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { reduxForm, Field } from 'redux-form'

// Form Components
import ReduxSchoolSearchInput from '../../../../components/Global/ReduxForms/ReduxSchoolSearchInput'
import ReduxDatePicker from '../../../../components/Global/ReduxForms/ReduxDatePicker'

// Helpers
import { required } from '../../../../utils/formValidators'

class SeasonForm extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    allowCancel: PropTypes.bool,
    onCancel: PropTypes.func
  }

  render() {
    const {
      accountDetails,
      allowCancel,
      onCancel,
    } = this.props

    return (
      <form onSubmit={this.props.handleSubmit} className="season-form">
        <Field
          name="season[school]"
          label="School"
          component={ReduxSchoolSearchInput}
          defaultSelectedItem={accountDetails.athlete_info.school}
          defaultInputValue={accountDetails.athlete_info.school.school_name}
          validate={required}
        />
        <Field
          name="season[starts_on]"
          type="text"
          label="Season start date"
          placeholder="2018-01-01"
          component={ReduxDatePicker}
          validate={required}
        />
        <Field
          name="season[ends_on]"
          type="text"
          label="Season end date"
          placeholder="2018-03-31"
          component={ReduxDatePicker}
          validate={required}
        />
        <div className="season-form-actions">
          <button className="cta-gradient" type="submit">
            Add Season
          </button>
          {
            allowCancel &&
            <a className="text-link" onClick={onCancel}>
              Cancel
            </a>
          }
        </div>
      </form>
    )
  }
}

SeasonForm = reduxForm({
  form: 'SeasonForm'
})(SeasonForm)

const mapStateToProps = (state) => ({
  accountDetails: state.accountDetails,
  initialValues: {
    season: {
      school: state.accountDetails.athlete_info.school,
    }
  }
})

export default connect(mapStateToProps)(SeasonForm)



// WEBPACK FOOTER //
// ./src/components/UserPortal/Locker/Stats/SeasonForm.js